import React from "react";
import { Ruler } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";

const TOPS = {
  cols: ["Size", "Chest (in)", "Length (in)", "Shoulder (in)"],
  rows: [
    ["S", "38–40", "27", "17"],
    ["M", "40–42", "28", "18"],
    ["L", "42–44", "29", "19"],
    ["XL", "44–46", "30", "20"],
    ["XXL", "46–48", "31", "21"],
    ["XXXL", "48–50", "32", "22"],
  ],
};

const BOTTOMS = {
  cols: ["Size", "Waist (in)", "Hip (in)", "Inseam (in)"],
  rows: [
    ["S", "28–30", "38", "7"],
    ["M", "30–32", "40", "7.5"],
    ["L", "32–34", "42", "8"],
    ["XL", "34–36", "44", "8.5"],
    ["XXL", "36–38", "46", "9"],
  ],
};

export const SizeGuide = ({ category = "Tops", sizes = [] }) => {
  const chart = category === "Bottoms" ? BOTTOMS : TOPS;
  const rows = sizes.length ? chart.rows.filter((r) => sizes.includes(r[0])) : chart.rows;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button data-testid="size-guide-button" className="label text-[#8A8F99] hover:text-[#0B0E14] transition-colors underline underline-offset-4 flex items-center gap-1.5">
          <Ruler className="w-3.5 h-3.5" strokeWidth={1.5} /> Size Guide
        </button>
      </DialogTrigger>
      <DialogContent data-testid="size-guide-dialog" className="bg-[#EDEEF1] border-[#0B0E14] rounded-none sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-3xl tracking-tight text-left">Size Guide</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#3A4150] -mt-1">
          {category === "Bottoms"
            ? "Relaxed streetwear fit. Measurements are garment measurements, laid flat."
            : "Boxy, true-to-size streetwear fit. Between sizes? Size up for the classic oversized look."}
        </p>
        <table className="w-full text-sm mt-2" data-testid="size-guide-table">
          <thead>
            <tr className="border-b border-[#0B0E14]">
              {chart.cols.map((c) => (
                <th key={c} className="label text-left py-2 pr-3 font-normal text-[#8A8F99]">{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(rows.length ? rows : chart.rows).map((r) => (
              <tr key={r[0]} className="border-b border-[#D4D7DD]">
                {r.map((cell, i) => (
                  <td key={chart.cols[i]} className={`py-2.5 pr-3 ${i === 0 ? "label" : ""}`}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <p className="label text-[#8A8F99] mt-1">Still unsure? DM us @funky.apparelll — we'll help you pick.</p>
      </DialogContent>
    </Dialog>
  );
};
